module.exports = __webpack_public_path__ + "img/hr-red-asterisk-12.70eeb111.png";